import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// A escala de fonte é própria (text-14…text-180, tokens.css): sem esse mapeamento
// o twMerge trata text-14 como cor e descarta text-chalk/text-amber quando um
// utilitário de tamanho vem depois (bug real: botões claros perdiam a cor do texto).
const merge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["14", "16", "18", "22", "28", "40", "56", "80", "120", "180"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return merge(clsx(inputs));
}
